export default {
    "h1": {
        variant: "subtitle1",
        rowHeight: 40
    },
    "d1": {
        variant: "body2",
        rowHeight: 25
    }
}